import React from 'react';
import ReactQuill from 'react-quill';

import EditorToolbar, { formats } from './EditorToollbar';

import 'react-quill/dist/quill.snow.css';
import styles from './QuillEditor.module.scss';

// REMOVE remove this component
const QuillEditor = ({ modules, value, setValue, placeholder, toolbarId, reference, readOnly, disabled, label }) => (
  <div className={styles.textEditor}>
    {label && <div className={styles.label}>{label}</div>}
    {!readOnly && <EditorToolbar customId={toolbarId} />}
    <ReactQuill
      value={value}
      onChange={(newValue, delta, source) => {
        if (source === 'user') {
          if (newValue.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
            return setValue(null);
          }
          setValue(newValue);
        }
      }}
      modules={modules}
      formats={formats}
      placeholder={placeholder}
      ref={reference}
      readOnly={readOnly}
      disabled={disabled}
    />
  </div>
);

export default QuillEditor;
